import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import InboxManagerMixin from '@/helpers/vue_mixins/v3/copilot_inbox_manager/InboxManagerMixin';
import FetchFacebookComments from '@/plugins/graphql/queries/v3/fetch-facebook-comments.gql';
import InboxFbComments from '@/plugins/graphql/subscriptions/v3/inbox-fb-comments.gql';
import UpdateGeneratedResponse from '@/plugins/graphql/mutations/copilot_inbox_manager/update-generated-response.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { EventBus, EventBusTriggers } from '@/helpers/EventBus';
import { AgentType } from '@/helpers/entities/enums/v3/Agent';
let InboxConversation = class InboxConversation extends Mixins(PaginatorMixin, AlertMixin, InboxManagerMixin) {
    constructor() {
        super(...arguments);
        this.selectedComment = {};
        this.isReplyingComment = {
            baseGlobalId: '',
            isReplyingValue: false,
            isEditing: false,
        };
        this.editableReplyMessage = '';
        this.isFetchMore = false;
        this.facebookComments = [];
        this.sendingMessages = [];
        this.sending = false;
    }
    onFacebookCommentsChanged() {
        EventBus.$emit(EventBusTriggers.setAgentBreakdown, this.facebookComments);
    }
    checkIfHasGeneratedResponse(message) {
        if (message && message.generatedResponse && message.generatedResponse.jsonCompletion) {
            return true;
        }
        return false;
    }
    getSentimentValue(message) {
        if (!message.agentBreakdown?.length)
            return null;
        const sentimentAnalysis = message?.agentBreakdown?.find((item) => item.type === AgentType.sentiment);
        return sentimentAnalysis?.jsonCompletion?.sentiment || null;
    }
    showBreakdown(message) {
        // document.getElementsByClassName("breakdown-1")[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        EventBus.$emit(EventBusTriggers.setInboxWidgetTab, 1);
        setTimeout(() => {
            const target = document.getElementsByClassName(`breakdown-${message.baseGlobalId}`)[0];
            const container = document.getElementsByClassName('agent-breakdown')[0];
            const offset = target.offsetTop - container.scrollTop;
            container.scrollBy({ top: offset, behavior: 'smooth' });
        }, 250);
    }
    mapNewFbComment(newFbComment) {
        this.shouldScrollToBottom = false;
        const { sender } = newFbComment;
        if (sender === 'customer') {
            const existingCommentIndex = this.facebookComments.findIndex((comment) => comment.baseGlobalId === newFbComment.baseGlobalId);
            if (existingCommentIndex !== -1) {
                // Update existing comment
                this.$set(this.facebookComments, existingCommentIndex, newFbComment);
            }
            else {
                // Add new comment
                this.facebookComments.push(newFbComment);
            }
        }
        else {
            this.facebookComments.forEach((comment) => {
                if (comment.commentId === newFbComment.parentId) {
                    // comment.commentReply.push(newFbComment);
                    const existingReplyIndex = comment.commentReply.findIndex((reply) => reply.baseGlobalId === newFbComment.baseGlobalId);
                    if (existingReplyIndex !== -1) {
                        // Update existing merchant reply
                        this.$set(comment.commentReply, existingReplyIndex, newFbComment);
                    }
                    else {
                        // Add new merchant reply
                        comment.commentReply.push(newFbComment);
                    }
                    if (newFbComment.generatedResponse === null) {
                        comment.generatedResponse = null;
                    }
                    const foundIndex = this.sendingMessages.findIndex((msg) => msg.reply === newFbComment.message);
                    if (foundIndex !== -1) {
                        // Remove the message at foundIndex from this.sendingMessages
                        this.sendingMessages.splice(foundIndex, 1);
                    }
                }
            });
        }
    }
    clickReply(message) {
        this.shouldScrollToBottom = false;
        this.isReplyingComment = { baseGlobalId: '', isReplyingValue: false, isEditing: false };
        const isReplyingValue = true;
        const selectedFbPost = { commentId: message.commentId, isReplyingValue };
        const comment = { baseGlobalId: message.baseGlobalId, isReplyingValue, isEditing: false };
        this.isReplyingComment = comment;
        this.$store.commit('setSelectedFbpost', selectedFbPost);
        this.$emit('clickReply');
    }
    getResponse(message) {
        if (message.generatedResponse?.jsonCompletion?.answer) {
            return message.generatedResponse?.jsonCompletion?.answer;
        }
        return message.generatedResponse?.completion;
    }
    approve(message) {
        this.sending = true;
        this.handleResponse(message, 'accept', '');
    }
    startEdit(message) {
        this.shouldScrollToBottom = false;
        this.editableReplyMessage = this.getResponse(message);
        this.isReplyingComment.isEditing = true;
        this.isReplyingComment.baseGlobalId = message.baseGlobalId;
    }
    dismiss(message) {
        this.handleResponse(message, 'dismiss', '');
    }
    sendEdit(message) {
        this.sending = true;
        this.handleResponse(message, 'edited', this.editableReplyMessage);
        this.isReplyingComment.isEditing = false;
    }
    cancelEdit() {
        this.isReplyingComment.isEditing = false;
    }
    handleResponse(message, action, editedMessage) {
        const promptUuid = message.generatedResponse.base.uuid;
        const { baseGlobalId } = message;
        this.updateGeneratedResponse(promptUuid, action, editedMessage, baseGlobalId);
    }
    updateGeneratedResponse(promptUuid, action, message, baseGlobalId) {
        this.shouldScrollToBottom = false;
        this.$apollo
            .mutate({
            mutation: UpdateGeneratedResponse,
            variables: {
                input: {
                    promptUuid,
                    action,
                    message: message || '',
                },
            },
        })
            .then((result) => {
            if (result) {
                if (action === 'accept' || action === 'edited') {
                    this.successNotification('Message sent successfully');
                }
                this.facebookComments.forEach((comment) => {
                    if (comment.baseGlobalId === baseGlobalId) {
                        comment.generatedResponse = null;
                    }
                });
                this.sending = false;
            }
        })
            .catch((e) => {
            this.errorNotification(e.message);
            this.sending = false;
        });
    }
    get displayPagePhoto() {
        const photo = this.post.page?.photoUrl;
        if (!photo) {
            return photo;
        }
        return this.defaultPhoto;
    }
    displayMessageImage(message) {
        if (message.galleryPhotos.edges.length > 0) {
            return message.galleryPhotos.edges.node.photoUrl;
        }
        return '';
    }
    fetchfacebookComments() {
        this.shouldScrollToBottom = false;
        if (this.isFetchMore) {
            return; // Do not fetch more if already in progress
        }
        const { endCursor, hasNextPage } = this.pageInfo;
        if (hasNextPage) {
            this.isFetchMore = true; // Set flag to indicate fetch in progress
            this.$apollo
                .query({
                query: FetchFacebookComments,
                variables: {
                    fbPostUuid: this.post.uuid,
                    pageRecipientUuid: this.selectedRecipient.uuid,
                    first: 5,
                    after: endCursor,
                },
            })
                .then(({ data }) => {
                this.pageInfo = data.fetchFacebookComments.pageInfo;
                const moreNodes = data.fetchFacebookComments.edges.map((edge) => edge.node);
                const sortNodes = moreNodes.slice().reverse();
                this.facebookComments = [...sortNodes, ...this.facebookComments];
                // For Smooth scrolling when new comments are added
                const container = this.$refs.messageContent;
                const originalScrollTop = container.scrollTop;
                this.$refs.messageContent.scrollTop =
                    originalScrollTop + sortNodes.length * this.getItemHeight();
                this.isFetchMore = false;
            })
                .catch((err) => {
                console.log(err);
                this.isFetchMore = false;
            });
        }
        else {
            this.isFetchMore = false;
        }
    }
    handleScroll(event) {
        const list = event.target;
        const { scrollTop } = list;
        if (scrollTop <= 0) {
            this.fetchfacebookComments();
        }
    }
    mounted() {
        this.scrollToBottom();
        this.displayRecipientPhoto();
    }
    updated() {
        this.scrollToBottom();
    }
    receiveComment(newString, comment_id) {
        this.sendingMessages.push({ reply: newString, commentId: comment_id });
    }
    deleteComment() {
        this.sendingMessages.shift();
    }
};
__decorate([
    Getter('selectedFbpost')
], InboxConversation.prototype, "selectedFbpost", void 0);
__decorate([
    Prop({ type: Object, required: true })
], InboxConversation.prototype, "post", void 0);
__decorate([
    Watch('facebookComments')
], InboxConversation.prototype, "onFacebookCommentsChanged", null);
InboxConversation = __decorate([
    Component({
        name: 'InboxConversation',
        computed: {
            filteredMessages() {
                return (comment) => {
                    return this.sendingMessages.filter((message) => {
                        return message.commentId === comment.commentId;
                    });
                };
            },
        },
        apollo: {
            facebookComments: {
                query: FetchFacebookComments,
                variables() {
                    return {
                        pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                        fbPostUuid: this.post.uuid,
                        first: 10,
                        after: this.startCursor,
                    };
                },
                skip() {
                    return !this.post;
                },
                fetchPolicy: 'network-only',
                update({ fetchFacebookComments }) {
                    if (fetchFacebookComments) {
                        const fbComments = fetchFacebookComments.edges.map((edge) => edge.node);
                        EventBus.$emit(EventBusTriggers.setAgentBreakdown, fbComments);
                        this.nodes = [...fbComments].reverse();
                        this.pageInfo = fetchFacebookComments.pageInfo;
                        this.shouldScrollToBottom = true;
                        return this.nodes;
                    }
                },
                subscribeToMore: {
                    document: InboxFbComments,
                    variables() {
                        return {
                            pageRecipientGlobalId: this.$store.state.selectedRecipient.baseUuid,
                            fbPostGlobalId: this.post.baseGlobalId,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        const { fbComment } = subscriptionData.data?.inboxFbComments;
                        this.mapNewFbComment(fbComment);
                        return subscriptionData.data.inboxFbComments.fbComment;
                    },
                },
            },
        },
    })
], InboxConversation);
export default InboxConversation;
